import { Typography } from '@material-ui/core';
import { CommunitySections } from './CommunitySections';
import Apps from '@material-ui/icons/Apps';
import AccountTree from '@material-ui/icons/AccountTree';
import Description from '@material-ui/icons/Description';
import Code from '@material-ui/icons/Code';
import People from '@material-ui/icons/People';
import { Content, Page, Link } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { ShortcutTile } from './ShortcutTile';
import { RecentlyViewed } from './RecentlyViewed';
import { LatestContent } from './LatestContent';
import { EmployeeTools } from './EmployeeTools';
import { useHomeStyles } from './homeStyles';
import { useFirstName } from './useFirstName';

export const HomePage = (): JSX.Element => {
  const classes = useHomeStyles();
  const name = useFirstName();
  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content className={classes.page}>
          <div data-testid="home-page">
            <a href="#home-main-content" className={classes.skip}>
              Skip to main content
            </a>
            <div id="home-main-content" tabIndex={-1}>
              <header className={classes.hero}>
                <div className={classes.heroIntro}>
                  <span className={classes.eyebrow}>Connected by Univerus</span>
                  <Typography component="h1" className={classes.title}>
                    {name ? `${name}, welcome to` : 'Welcome to'}{' '}
                    <span className={classes.titleAccent}>
                      Univerus Central.
                    </span>
                  </Typography>
                  <p className={classes.heroDescription}>
                    Find what you need, connect with your people, and discover
                    the latest across Univerus.
                  </p>
                  <div className={classes.heroSearch}>
                    {/* Public props only: the label stays for screen readers. */}
                    <HomePageSearchBar
                      margin="none"
                      InputLabelProps={{ className: classes.visuallyHidden }}
                      InputProps={{
                        classes: {
                          root: classes.search,
                          focused: classes.searchFocused,
                          notchedOutline: classes.searchOutline,
                        },
                      }}
                      placeholder="Search products, knowledge and people…"
                      label="Search Univerus Central"
                    />
                  </div>
                  <div className={classes.heroActions}>
                    <nav
                      className={classes.suggestions}
                      aria-label="Suggested searches"
                    >
                      <span>Popular</span>
                      <Link to="/search?query=asset%20management">
                        Asset management
                      </Link>
                      <Link to="/search?query=onboarding">Onboarding</Link>
                      <Link to="/search?query=teams">Teams</Link>
                    </nav>
                  </div>
                </div>
              </header>
              <nav className={classes.startHere} aria-label="Quick links">
                <ShortcutTile to="/products" label="Products" icon={<Apps />} />
                <ShortcutTile
                  to="/catalog"
                  label="Service Catalog"
                  icon={<AccountTree />}
                />
                <ShortcutTile
                  to="/docs"
                  label="Knowledge Base"
                  icon={<Description />}
                />
                <ShortcutTile to="/api-docs" label="APIs" icon={<Code />} />
                <ShortcutTile to="/groups" label="Teams" icon={<People />} />
              </nav>
              <RecentlyViewed />
              <div className={classes.lower}>
                <LatestContent />
                <aside aria-label="Resources" className={classes.resources}>
                  <EmployeeTools />
                </aside>
              </div>
              <CommunitySections />
            </div>
          </div>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
export default HomePage;
